import loader from '@/utils/loader'

export default loader.getByCustom(require.context('./', true, /\/index\.vue$/), (componentMap, component, path) => {
  const OPTION_TYPE = component.OPTION_TYPE
  componentMap[OPTION_TYPE] = {
    optionType: OPTION_TYPE,
    componentName: component.name,
    getSelected: component.getSelected
  }
})



// WEBPACK FOOTER //
// ./src/components/Data/TaskResult/CheckOptTypeMap.js